export function isRtlLanguage(language) {
  return language === "he" || language === "iw";
}

export function getDirection(language) {
  return isRtlLanguage(language) ? "rtl" : "ltr";
}
